import { useTranslation } from 'react-i18next';

import { IconButton } from '@mui/material';
import { Tooltip } from 'common/components';
import { HelpOutlinedIcon } from 'icons';

const HELP_CENTER_URL = window._env_.VITE_APP_INTERCOM_URL;

export const GoToHelpCenter = () => {
  const { t } = useTranslation('common', { keyPrefix: 'topBar.helpCenter' });

  if (!HELP_CENTER_URL) {
    return null;
  }

  return (
    <Tooltip title={t('title')}>
      <IconButton
        size="medium"
        href={HELP_CENTER_URL}
        target="_blank"
        rel="noreferrer"
        sx={{ borderRadius: '50%', '& .MuiSvgIcon-root': { fontSize: 24 } }}
      >
        <HelpOutlinedIcon />
      </IconButton>
    </Tooltip>
  );
};
